<template>

  <div>
    <!-- END: Data List -->
    <div id="rough-process-reject-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-body p-10">
            <!-- <div id="vertical-form"> -->
            <div class="flex flex-col justify-between mt-5">
              <!-- BEGIN: Data List -->
              <div class="intro-y overflow-auto">
                <div class="flex items-center">
                  <h2 class="intro-y text-lg font-medium mr-5">Add Rejection</h2>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="intro-y col-span-12">
                  <!-- BEGIN: Input -->
                  <div class="">
                    <div id="input" class="py-5">
                      <div class="preview">
                        <div>
                          <!-- <label class="form-label">Kapan No & Stone Type</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div class="">
                                <div id="input-group-4">Kapan</div>

                                <input id="pos-form-1" v-model="reject_form.kapan" name="kapan" type="text" disabled
                                  class="form-control flex-1" placeholder="Kapan No" />
                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div id="input-group-3" class="">Stone</div>
                              <select class="form-select" v-model="reject_form.stone_id" disabled
                                aria-label="Default select example">
                                <option v-for="item in page_data.stones" :key="item.id" :value="item.id">
                                  {{ item.stone_name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <!-- <label class="form-label">No. of Pieces & Total Weight</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div>

                                <div class="">
                                  <div id="input-group-3">Available Pieces</div>
                                  <input type="text" class="form-control" name="piece" disabled
                                    v-model="reject_form.avail_pcs" aria-describedby="input-group-3" />
                                </div>

                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div class="">
                                <div id="input-group-4">Available Weight (Ct)</div>
                                <input type="text" class="form-control" name="weight" disabled
                                  v-model="reject_form.avail_wt" aria-describedby="input-group-4" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="mt-3" v-if="reject_form.purchase_type == 2">
                                                    <div id="input-group-3" class="">Stone</div>
                                                    <select class="form-select w-full" v-model="reject_form.rejection_type" aria-label="Default select example">
                                                        <option value="1">Direct Rejection</option>
                                                        <option value="2" v-if="reject_form.purchase_type == 2">Net Rejection</option>
                                                    </select>
                                              </div> -->
                        <div class="mt-3">
                          <!-- <label class="form-label">No. of Pieces & Total Weight</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>
                              <div>

                                <div class="">
                                  <div id="input-group-3">Pieces</div>
                                  <input type="text" class="form-control" name="piece" autocomplete="off"
                                    @keypress="$h.preventInvalidInput" v-model="reject_form.pieces"
                                    placeholder="No of Pieces" aria-describedby="input-group-3" />
                                </div>
                                <!-- <template v-if="reject_validate.pieces.$error">
                                                                  <div v-for="(error, index) in reject_validate.pieces.$errors" :key="index" class="text-theme-6 mt-2">
                                                                      {{ error.$message }}
                                                                  </div>
                                                              </template> -->

                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div class="">
                                <div id="input-group-4" :class="{ 'border-theme-6': reject_validate.weight.$error }">
                                  Weight
                                  (Ct) <span class="text-theme-6"> * </span></div>
                                <input type="text" class="form-control" name="weight"
                                  :class="{ 'border-theme-6': reject_validate.weight.$error }" autocomplete="off"
                                  @keypress="$h.preventInvalidInput" v-model="reject_form.weight" placeholder="Weight"
                                  aria-describedby="input-group-4" />
                              </div>
                              <template v-if="reject_validate.weight.$error">
                                <div v-for="(error, index) in reject_validate.weight.$errors" :key="index"
                                  class="text-theme-6 mt-2">
                                  {{ error.$message }}
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <!-- <label class="form-label">Stone && Est Value</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>

                              <div class="">

                              </div>
                            </div>
                            <div>
                              <div class="mt-2 sm:mt-0">
                                <div class="flex justify-end items-center mt-5">
                                  <button type="button" :disabled="page_data.r_loading == true"
                                    class="btn btn-secondary w-24 m-auto mr-3" data-dismiss="modal"
                                    href="javascript:;">Cancel</button>
                                  <button type="button" @click="process_reject" :disabled="page_data.r_loading == true"
                                    class="btn btn-primary w-24 m-auto"> Reject
                                    <LogInIcon v-if="page_data.r_loading == false" class="h-4 w-4 ml-2 -mt-1" />
                                    <LoadingIcon v-if="page_data.r_loading == true" icon="oval" color="white"
                                      class="w-4 h-4 ml-2" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END: Input -->
                </div>
              </div>
              <!-- END: Data List -->
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: Single Process Assign Modal -->
  </div>

</template>

<script setup>
/* eslint-disable */
import {
  BASE_URL
} from '@/constants/config'
import {
  useVuelidate
} from '@vuelidate/core'
import axios from 'axios'
import cash from 'cash-dom'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  integer
} from '@vuelidate/validators'
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  reactive,
  ref,
  toRefs,
  watch
} from 'vue'
import {
  helper as $h
} from '@/utils/helper'
import router from '@/router'
import Swal from 'sweetalert2'
import {
  useStore
} from '@/store'

const swal = inject('$swal')
const store = useStore()
const user_details = computed(() => store.state.user.currentUser)
const settings = computed(() => store.state.user.settings)

const page_data = reactive({
  r_loading: false

})

const reject_rules = {
  weight: {
    required,
  }
}

const reject_form = reactive({
  rejection_type: '1',
  purchase_type: '1',
  pieces: '',
  weight: '',
  purchase_id: '',
  kapan: '',
  lot_no: '',
  stone_id: '',
  avail_pcs: '',
  avail_wt: '',
})

const reject_validate = useVuelidate(reject_rules, toRefs(reject_form))


const resetForm = (item) => {

  cash('#rough-process-reject-modal').modal('show')

  reject_form.purchase_id = item.id
  reject_form.kapan = item.voucher_no
  reject_form.lot_no = item.lot_no
  reject_form.avail_pcs = item.cr_pcs
  reject_form.purchase_type = item.purchase_type
  reject_form.rejection_type = item.purchase_type == 1 ? '1' : '2'
  reject_form.avail_wt = item.cr_wt
  reject_form.stone_id = String(item.stone_type)

}

const process_reject = async () => {

  reject_validate.value.$touch()
  if (reject_validate.value.$invalid) {
    swal('Error', 'Fields are empty.', 'error');
    return
  }

  const params = {
    rejection_type: (reject_form.rejection_type != '' ? window.btoa(reject_form.rejection_type) : ''),
    pieces: (reject_form.pieces != '' ? window.btoa(reject_form.pieces) : ''),
    weight: (reject_form.weight != '' ? window.btoa(reject_form.weight) : ''),
    id: (reject_form.purchase_id != '' ? window.btoa(reject_form.purchase_id) : ''),
    ip: localStorage.getItem('sk_key')
  }

  let promise_url = 'api/kpn/rrp'
  page_data.r_loading = true

  let promise = axios({
    url: promise_url,
    method: "POST",
    data: params,
    baseURL: BASE_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),

    },
    config: {
      headers: {
        Accept: "application/json"
      }
    }
  });
  return promise
    .then(result => result.data)
    .then(data => {

      if (data.status == 'error') {
        swal('Warning', data.message, 'warning');
        page_data.r_loading = false
      } else {
        swal('Success', data.message, 'success');

        reject_form.rejection_type = '1'
        reject_form.pieces = ''
        reject_form.weight = ''
        reject_form.purchase_id = ''
        reject_form.kapan = ''
        reject_form.lot_no = ''
        reject_form.stone_id = ''
        reject_form.avail_pcs = ''
        reject_form.avail_wt = ''
        page_data.r_loading = false

        cash('#rough-process-reject-modal').modal('hide')
        reject_validate.value.$reset()
        initTabulator()
      }
    })
    .catch(_error => {
      page_data.r_loading = false
      swal('Error', 'Something went wrong.', 'error');
    });

}

defineExpose({
  resetForm
})


</script>
